/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Added2Inputs */

const en_coinvestments_dataroom_added2 = /** @type {(inputs: Coinvestments_Dataroom_Added2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added`)
};

/**
* | output |
* | --- |
* | "Added" |
*
* @param {Coinvestments_Dataroom_Added2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_added2 = /** @type {((inputs?: Coinvestments_Dataroom_Added2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Added2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_added2(inputs)
});
export { coinvestments_dataroom_added2 as "coInvestments_dataRoom_added" }